import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IPharmacyDTO } from 'src/app/_models/PSP/pharmacy.model';
import { PharmaciesService } from 'src/app/_services/PSP/pharmacies.service';

@Component({
  selector: 'app-pharmacies',
  templateUrl: './pharmacies.component.html',
  styleUrls: ['./pharmacies.component.scss']
})
export class PharmaciesComponent implements OnInit {
  pageTitle: string = 'All Pharmacies';
  placeholder: string = 'Search by pharmacy name';
  searchValue: string;
  theadArray: string[] = ['Name', 'Address'];
  modifiedPharmaciesList: {id: string, name: string, address: string}[] = [];

  constructor(private pharmaciesService: PharmaciesService,
    private router: Router) { }

  ngOnInit(): void {
    this.getAllPharmacies(null);
  }

  onSearchSubmit(value: string){
    this.searchValue = value;
    this.getAllPharmacies(value);
  }

  onSearchKeyup(searchString) {
    if (!searchString && (searchString.trim() != this.searchValue.trim())) {
      this.searchValue = '';
      this.getAllPharmacies(null);
    }
  }

  getAllPharmacies(searchValue: string){
    this.pharmaciesService.getAllPharmacies(searchValue).subscribe(res => {
      this.modifiedPharmaciesList = this.modifyPharmaciesList(res.data.pharmacies);
    });
  }

  modifyPharmaciesList(pharmacies: IPharmacyDTO[]){
    return pharmacies.map(p => {
      return {
        id: p.id,
        name: p.name,
        address: p.address
      }
    });
  }

  routeToPharmacyDetails(pharmacy: {id: string, name: string, address: string}){
    this.router.navigate(['psp', 'psp-pharmacy-details'], {
      queryParams: { pharmacyErpId: pharmacy.id},
    });
  }
}
